module.exports = __webpack_public_path__ + "img/70.6.CODm.63774994.png";